import React, {PropsWithChildren} from 'react';
import cx from 'classnames';
import styles from './IconContent.module.scss';

export default function IconContent({ icon, children, inverseColors, noMargin }: PropsWithChildren<{
  inverseColors?: boolean;
  noMargin?: boolean;
  icon: React.JSX.Element;
}>) {
    return (
        <div
            className={cx({
                "d-flex": true,
                "mb-5": !noMargin,
                "mb-2": noMargin,
            })}
        >
            <div className="me-3">{icon}</div>
            <div
                className={cx({
                    'text-left': true,
                    [styles.InverseColors]: inverseColors
                })}
            >
                {children}
            </div>
        </div>
    );
}
